import { IClause } from "@/api";

import { UserChip } from "@/components/shared/chips/UserChip";
import { ClauseTypesCell } from "@/components/shared/table/cells/ClauseTypesCell";
import { PolicyTypeCell } from "@/components/shared/table/cells/PolicyTypeCell";
import { useAuth } from "@/contexts/auth/useAuth";
import { Stack, Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useDialogs } from "@toolpad/core/useDialogs";
import { ClauseDetailsDialog } from "../dialogs/clause-details-dialog/ClauseDetailsDialog";

/**
 * Renders a clause as a list view cell intended for mobile devices
 */
export const ClauseListViewCell = (params: GridRenderCellParams<IClause>) => {
    const dialog = useDialogs();
    const { user } = useAuth();

    const handleClick = () => {
        dialog.open(ClauseDetailsDialog, {
            clause: params.row,
            user,
        });
    };

    return (
        <div onClick={handleClick}>
            <Stack
                direction="row"
                gap={2}
                sx={{
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                }}
            >
                <Stack gap={1} sx={{ flexGrow: 1, maxWidth: "100%" }}>
                    <Typography variant="body2" fontWeight={600}>
                        {params.row.title}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        noWrap
                        gutterBottom
                    >
                        {params.row.description}
                    </Typography>
                    <Stack direction="row" gap={1} flexWrap={"wrap"}>
                        <UserChip insureScope size="small" />
                    </Stack>
                    <Stack direction="row" gap={1} flexWrap={"wrap"}>
                        <PolicyTypeCell policyType={params.row.policy_type} />
                        <ClauseTypesCell
                            clauseTypes={params.row.clause_types}
                        />
                    </Stack>
                </Stack>
            </Stack>
        </div>
    );
};
